import React from "react";
import { useTranslation } from "react-i18next";

const WORDMARKS = [
    "Mirqab", "JAZEERA×", "Thaqafa", "SOUQ / KHAIR",
    "Falaj.io", "Neom Works", "Riyadh Rail", "Oasis Capital",
    "Athar Studio", "Bayt Records", "Qimam", "Hilal & Co.",
];

export const TrustedBy = () => {
    const { t } = useTranslation();
    const doubled = [...WORDMARKS, ...WORDMARKS];
    return (
        <section
            className="border-y-2 border-ink-200 bg-mudbrick-200 py-7"
            data-testid="trusted-by"
        >
            <div className="mx-auto max-w-[1320px] px-5 lg:px-8">
                <div className="flex flex-col items-baseline gap-4 sm:flex-row sm:items-center sm:gap-8">
                    <p className="eyebrow-teal shrink-0 text-[14px]">
                        {t("home.trustedBy")}
                    </p>
                    <div className="relative flex-1 overflow-hidden">
                        <div className="pointer-events-none absolute inset-y-0 start-0 z-10 w-20" style={{ background: "linear-gradient(90deg, #F0ECE1 30%, transparent 100%)" }} />
                        <div className="pointer-events-none absolute inset-y-0 end-0 z-10 w-20" style={{ background: "linear-gradient(270deg, #F0ECE1 30%, transparent 100%)" }} />
                        <div className="flex items-center gap-14 whitespace-nowrap will-change-transform animate-ticker">
                            {doubled.map((w, i) => (
                                <span
                                    key={i}
                                    className="font-display text-[20px] font-semibold tracking-tight text-ink-700"
                                    data-testid={`trustmark-${w.replace(/\s|\W/g, "-").toLowerCase()}`}
                                >
                                    {w}
                                </span>
                            ))}
                        </div>
                    </div>
                </div>
            </div>
        </section>
    );
};
